import { createFileRoute, Navigate } from "@tanstack/react-router";
import { LaunchScreen } from "@optymyse/suite-ui";
import { useMe, signedIn } from "../lib/auth";
import { centralUrl, onCentralHost } from "../lib/hosts";
import { SignIn } from "../components/auth/SignIn";

// `/` on the central host is the way in; on a workspace's own host it is that workspace's console.
function HomePage() {
  return onCentralHost() ? <WayIn /> : <Navigate to="/admin" />;
}

// Nobody without a session cookie gets here: the Worker sends them straight to sign in (src/worker/index.ts), as
// Assure's and Unlock's central addresses do. Steer's launch shows while it learns who is here, as the console opens
// with it; then the signed-in person's workspaces. Anyone else, a session that has ended since among them, goes
// straight on to sign in too, the launch staying meanwhile.
function WayIn() {
  const me = useMe();
  if (me.isLoading) return <LaunchScreen product="steer" />;
  // Signed in: the list of workspaces, which opens the only one directly.
  if (signedIn(me)) return <Navigate to="/admin" />;
  return <SignIn returnTo={centralUrl("/admin")} />;
}

export const Route = createFileRoute("/")({ component: HomePage });
